export default "__VITE_PUBLIC_ASSET__5ee9b8e2__"